import { create } from "zustand";

export interface AuthData {
  token: string | null;
  username: string | null;
  role: string | null;
  organisationId: number | null;
  /** Optional account ID returned by the login payload (used e.g. for CSV upload). */
  accountId: number | null;
  /** Whether the user has completed onboarding. */
  onboarded: boolean;
  isAuthenticated: boolean;
  hasSubscription: boolean;
  subscriptionStatus: 'ACTIVE' | 'INACTIVE' | 'CANCELED_AT_PERIOD_END' | 'TRIALING' | 'PAST_DUE' | 'CANCELED' | null;
}

interface AuthStore extends AuthData {
  setAuth: (data: Partial<Omit<AuthStore, "setAuth" | "clearAuth">>) => void;
  clearAuth: () => void;
}

const defaultState: AuthData = {
  token: null,
  username: null,
  role: null,
  organisationId: null,
  accountId: null,
  onboarded: false,
  isAuthenticated: false,
  hasSubscription: false,
  subscriptionStatus: null,
};

export const useAuthStore = create<AuthStore>((set) => ({
  ...defaultState,

  setAuth: (data) => set((state) => ({ ...state, ...data })),

  clearAuth: () => set(defaultState),
}));
